import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import user_icon from "../../images/reg_user.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function SecureIdentityVerificationNextPhase() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    return (
        <>
            <Header />
            <Container fluid className='bg-sky min-vh-custom'>
                <Row>
                    <Col md={12}>
                        <div className='mt-5'>
                            <Col md={3} className='text-center py-4'>
                                <Row className='justify-content-center'>
                                    <BackButton />
                                </Row>
                            </Col>

                            <Col md={12} className='text-center justify-content-center'>
                                <img src={user_icon} width={50} />
                                <h3 className='text-center mt-3 mb-4'>{t('login.secure_title')}</h3>

                                <Row className='justify-content-center text-center'>
                                    <Col md={4} className='bg-white rounded-3' style={{ width: '540px' }}>
                                        <Form noValidate validated={validated}>
                                            <Row className="mb-3">
                                                <label className="form-label mt-3 fw-bold">{t('login.how_verify')}</label>
                                                <span className='text-secondary small'>{t('login.biometric_desc')}</span>
                                                <Link to={""} className='text-primary mt-3 small'>{t('login.learn_identity')}</Link>
                                            </Row>

                                            <Row className='justify-content-center'>
                                                <Col md={9}>
                                                    <Row className='d-flex align-items-center text-center'>
                                                        <Button type="submit" variant='' className="btn rounded-5 border-0 text-white" style={{ background: '#0B1628' }} onClick={() => { navigate('/consent_decline') }}>{t('login.accept_continue')}</Button>
                                                        <Link to={""} className='text-primary mt-3 small'>{t('login.no_verify')}</Link>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default SecureIdentityVerificationNextPhase;
